import styled from "@emotion/styled";

export const ListItemTitle = styled("h6")`
    ${({ theme }) => theme.text.h6}
    position: relative;
    color: ${({ theme }) => theme.colors.primary.gunmetal["1000"]};
    margin: 0;
`;
